import React from 'react';
import { useReveal } from '../hooks/useReveal';
import ContactInfo from './contact/ContactInfo';
import ContactForm from './contact/ContactForm';

export default function Contact() {
  const { ref, inView } = useReveal();
  return (
    <section id="contact" className="py-20 md:py-28 bg-[var(--pca-blue-tint)]">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="section-eyebrow">GET IN TOUCH</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">We'd love to hear from you</h2>
          <p className="mt-4 text-slate-600">Reach out to us for admission enquiries, campus visits, or any other information.</p>
        </div>

        <div className="mt-12 grid lg:grid-cols-5 gap-6">
          <ContactInfo />
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
